import React, { FC, useRef } from 'react';
import { useSelector } from 'react-redux';
import { Typography } from 'fronton-react';
import { getTitle } from 'features/page-model/ducks/get-model';
import { getCompanyId } from 'features/store/ducks/get-store-by-id';
import { useIntersectionObserverCallback } from '@navi-toolbox/hooks';
import { reviewsContainer, reviewsWidget, reviewsLink, reviewsHeader, reviewsFrame } from './styles';
import { analyticsUtils } from '../../utils';

export const StoreReviews: FC = () => {
  const title = useSelector(getTitle);
  const companyId = useSelector(getCompanyId);
  const reviewsBlockRef = useRef<HTMLDivElement | null>(null);

  useIntersectionObserverCallback(reviewsBlockRef, {
    enter: () => {
      analyticsUtils.sendEvent('GA:show', {
        elementType: 'block',
        elementBlock: 'shopPage', // блок, в котором расположен элемент
        elementName: 'Reviews',
        elementText: `Отзывы о ${title}`, // заголовок блока
      });
    },
    options: { threshold: 0.3 },
    extraUnobserve: 'enter',
  });

  if (!companyId) {
    return null;
  }

  return (
    <section className={reviewsContainer} data-qa="ReviewsSection">
      <Typography color="text-primary" variant="h3" className={reviewsHeader} data-qa="ReviewsTitle">
        {`Отзывы о ${title}`}
      </Typography>
      <div className={reviewsWidget} data-qa="ReviewsWidget" ref={reviewsBlockRef}>
        <iframe
          className={reviewsFrame}
          title="Отзывы на Яндекс Картах"
          src={`https://yandex.ru/maps-reviews-widget/${companyId}?comments`}
          data-qa="ReviewsFrame"
        />
        <a
          className={reviewsLink}
          href={`https://yandex.ru/maps/org/lerua_merlen/${companyId}/`}
          target="_blank"
          rel="noreferrer"
          data-qa="ReviewsLink"
        >
          {`${title} - Яндекс\u00A0Карты`}
        </a>
      </div>
    </section>
  );
};
